import React from "react";
import Sidebar from "../../components/Sidebar";

function Dashboard() {
  return (
    <>
      <div className="container-fluid p-4">
        <div className="mb-4">
          <h2 className="fw-bold">Welcome back, Alex! 👋</h2>
          <p className="text-muted">
            Full Stack Development Internship • Batch 24 • Week 6
          </p>
        </div>
        <div className="row g-4">
          <div className="col-lg-8">
            <div className="card live-hero-card mb-4 border-0 shadow-sm overflow-hidden">
              <div className="row g-0 h-100">
                <div className="col-md-8 p-4 d-flex flex-column justify-content-center">
                  <div className="live-status mb-2">
                    <span className="dot" /> LIVE NOW
                  </div>
                  <h3 className="fw-bold">
                    Advanced React Patterns &amp; Hooks
                  </h3>
                  <p className="text-muted">
                    Dr. Sarah Lin • Duration: 90 mins
                  </p>
                  <button className="btn btn-lg mt-3 fit-content d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined">videocam</span>{" "}
                    Join Live Class
                  </button>
                </div>
                <div
                  className="col-md-4 class-preview"
                  style={{
                    backgroundImage:
                      'url("https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=400")',
                  }}
                >
                  <div className="play-overlay">
                    <span className="material-symbols-outlined">
                      play_arrow
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-4 mb-4">
              <div className="col-md-4">
                <div className="card stat-card p-4 border-0 shadow-sm">
                  <div className="d-flex align-items-center gap-2 text-success mb-2">
                    <span className="material-symbols-outlined">
                      co_present
                    </span>
                    <span className="fw-semibold">Attendance</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <h5 className="fw-bold mb-0">85%</h5>
                    <small className="text-success">+2% vs last week</small>
                  </div>
                  {/* <div class="progress mt-3" style="height: 6px;">
                                  <div class="progress-bar" style="width: 85%"></div>
                              </div> */}
                </div>
              </div>
              <div className="col-md-4">
                <div className="card stat-card p-4 border-0 shadow-sm">
                  <div className="d-flex align-items-center gap-2 text-warning mb-2">
                    <span className="material-symbols-outlined">
                      pending_actions
                    </span>
                    <span className="fw-semibold">Pending Tasks</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <h5 className="fw-bold mb-0">2</h5>
                    <small className="text-warning">Due within 2 days</small>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card stat-card p-4 border-0 shadow-sm">
                  <div className="d-flex align-items-center gap-2 text-purple mb-2">
                    <span className="material-symbols-outlined">
                      hourglass_top
                    </span>
                    <span className="fw-semibold">Remaining</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <h5 className="fw-bold mb-0">45 Days</h5>
                    <small className="text-muted">Ends Dec 15</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="card border-0 shadow-sm p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="fw-bold mb-0">Current Assignments</h5>
                <a href="#" className="text-decoration-none small fw-bold">
                  View All
                </a>
              </div>
              <div className="assignment-list d-flex flex-column gap-3">
                <div className="assignment-item d-flex align-items-center justify-content-between p-3 border rounded">
                  <div className="d-flex align-items-center gap-3">
                    <div className="icon-wrap bg-orange-light text-orange">
                      <span className="material-symbols-outlined">code</span>
                    </div>
                    <div>
                      <h6 className="mb-0 fw-bold">
                        Project 2: E-commerce API
                      </h6>
                      <small className="text-muted">
                        Backend Development • Due Tomorrow
                      </small>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="badge bg-warning-subtle text-warning">
                      Pending
                    </span>
                    <button className="btn btn-outline-secondary btn-sm">
                      <span className="material-symbols-outlined fs-6 align-middle">
                        upload_file
                      </span>
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card border-0 shadow-sm p-4 mb-4">
              <h5 className="fw-bold mb-4">Internship Progress</h5>
              <div className="d-flex flex-column align-items-center">
                <div className="circle-progress-box mb-3">
                  <svg viewBox="0 0 36 36" className="circular-chart primary">
                    <path
                      className="circle-bg"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path
                      className="circle"
                      strokeDasharray="65, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                  </svg>
                  <div className="percentage">65%</div>
                </div>
                <div className="alert  border-0 small py-2 w-100">
                  <span className="material-symbols-outlined align-middle fs-6">
                    lock
                  </span>
                  <strong className="ms-1">Certificate Locked</strong>
                  <p className="mb-0 mt-1 opacity-75">
                    Complete 100% to unlock.
                  </p>
                </div>
              </div>
            </div>
            <div className="card border-0 shadow-sm p-4 mb-4">
              <h5 className="fw-bold mb-4">Schedule</h5>
              <div className="calendar-strip d-flex gap-2 overflow-auto pb-2">
                <div className="day-item active">
                  <span>Mon</span>
                  <strong>12</strong>
                </div>
                <div className="day-item">
                  <span>Tue</span>
                  <strong>13</strong>
                </div>
                <div className="day-item">
                  <span>Wed</span>
                  <strong>14</strong>
                </div>
                <div className="day-item">
                  <span>Thu</span>
                  <strong>15</strong>
                </div>
              </div>
              <div className="timeline mt-4">
                <div className="timeline-item active">
                  <small>10:00 AM</small>
                  <p>React Fundamentals</p>
                </div>
                <div className="timeline-item">
                  <small>02:00 PM</small>
                  <p>Design QA Review</p>
                </div>
              </div>
            </div>
            <div className="card border-0 shadow-sm p-4">
              <h5 className="fw-bold mb-3">Batch Instructor</h5>
              <div className="d-flex align-items-center gap-3 mb-4">
                <img
                  src="https://i.pravatar.cc/150?u=sarah"
                  className="rounded-circle"
                  width={56}
                  height={56}
                  alt="Sarah"
                />
                <div>
                  <h6 className="mb-0 fw-bold">Dr. Sarah Lin</h6>
                  <small className="text-muted">
                    Senior Full Stack Engineer
                  </small>
                </div>
              </div>
              <div className="row g-2">
                <div className="col-6">
                  <button className="btn btn-light w-100 btn-sm fw-bold">
                    Message
                  </button>
                </div>
                <div className="col-6">
                  <button className="btn btn-light w-100 btn-sm fw-bold">
                    Book 1:1
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade glass-modal"
        id="internshipModal"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content border-0">
            <button
              type="button"
              className="btn-close-v3"
              data-bs-dismiss="modal"
            >
              <span className="material-symbols-outlined">close</span>
            </button>
            <div className="modal-body p-0 overflow-hidden">
              <div className="premium-wrapper">
                <div className="header-section text-center">
                  <span className="premium-badge">2026 INTERNSHIP COHORT</span>
                  <h2 className="title-v3">
                    Accelerate Your <span className="accent-text">Career.</span>
                  </h2>
                  <p className="subtitle-v3">
                    Choose a professional track designed for industry mastery.
                  </p>
                </div>
                <div className="row g-4 px-lg-5 pb-5 pt-4 justify-content-center">
                  <div className="col-md-4">
                    <div className="offer-card">
                      <div className="card-inner">
                        <div className="plan-type">FAST TRACK</div>
                        <h3 className="duration">45 Days</h3>
                        <div className="price">
                          ₹4,999<span>/total</span>
                        </div>
                        <ul className="benefit-list">
                          <li>
                            <span className="check-icon">✓</span> Project
                            Foundation
                          </li>
                          <li>
                            <span className="check-icon">✓</span> ISO
                            Certification
                          </li>
                          <li>
                            <span className="check-icon">✓</span> Live Mentor
                            Access
                          </li>
                        </ul>
                        <button className="btn-premium-outline">
                          Select Plan
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="offer-card pro-featured">
                      <div className="popular-tag">MOST PREFERRED</div>
                      <div className="card-inner">
                        <div className="plan-type">PROFESSIONAL</div>
                        <h3 className="duration">3 Months</h3>
                        <div className="price">
                          ₹9,999<span>/total</span>
                        </div>
                        <ul className="benefit-list">
                          <li>
                            <span className="check-icon">✓</span> Advanced
                            Backend/UI
                          </li>
                          <li>
                            <span className="check-icon">✓</span> Placement
                            Training
                          </li>
                          <li>
                            <span className="check-icon">✓</span> ISO Verified
                            Credentials
                          </li>
                        </ul>
                        <button className="btn-premium-solid">
                          Get Started Now
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="offer-card">
                      <div className="card-inner">
                        <div className="plan-type">EXPERT MASTER</div>
                        <h3 className="duration">6 Months</h3>
                        <div className="price">
                          ₹14,999<span>/total</span>
                        </div>
                        <ul className="benefit-list">
                          <li>
                            <span className="check-icon">✓</span> Full Stack
                            Portfolio
                          </li>
                          <li>
                            <span className="check-icon">✓</span> LOR &amp;
                            Internship Cert
                          </li>
                          <li>
                            <span className="check-icon">✓</span> Priority
                            Placements
                          </li>
                        </ul>
                        <button className="btn-premium-outline">
                          Select Plan
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
